import { ReactElement } from "react"
import styled from "@emotion/styled"
import { Box, Hidden } from "@mui/material"

import { useTranslation } from "../TranslationProvider"
import { zIndex } from "../lib/theme"

export default function IntroText(): ReactElement {
  const { t } = useTranslation()

  return (
    <TextWrapper>
      <Hidden lgDown>
        <LeftText>{t("introText.left")}</LeftText>
      </Hidden>

      <MiddleText>
        <h2>{t("introText.middle.title")}</h2>

        <h3>{t("introText.middle.subTitle1")}</h3>
        <p>{t("introText.middle.text1")}</p>

        <h3>{t("introText.middle.subTitle2")}</h3>
        <p>{t("introText.middle.text2")}</p>

        <h2 translate="no">Step the Gap - Keeps the Disco alive!</h2>
      </MiddleText>

      <Hidden lgDown>
        <RightText>{t("introText.right")}</RightText>
      </Hidden>
    </TextWrapper>
  )
}

const TextWrapper = styled(Box)`
  position: relative;
  z-index: ${zIndex.introText};

  margin-top: max(-340px, -25vw);

  display: flex;
  flex-direction: row;
  justify-content: center;

  user-select: none;

  animation: fadeIn 2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 100;
    }
  }
`

const MiddleText = styled.div`
  border-radius: 0.5rem;
  box-shadow: inset 0 0 2rem 1rem rgba(0, 0, 0, 0.4);

  padding: 1rem;

  flex: 0 0 90%;

  background-color: rgba(79, 44, 114, 0.6);
  text-align: center;
  font-size: 0.8rem;

  @media screen and (min-width: 500px) {
    font-size: 1rem;
  }

  * {
    margin: 0;
  }

  h2,
  p {
    margin-bottom: 1.5rem;
  }

  h2:last-child {
    margin: 0;
  }

  @media screen and (min-width: 1200px) {
    flex: 0 0 40%;
  }
`

const SideText = styled.div`
  flex: 0 0 25%;

  margin-top: 3rem;

  padding: 1rem;
  max-width: 30rem;

  line-height: 1.5rem;
  font-size: 1.2rem;
  text-shadow: 0 0 3rem rgba(0, 0, 0, 0.5);
`

const LeftText = styled(SideText)`
  text-align: right;
`

const RightText = styled(SideText)`
  text-align: left;
`
